module.exports = __webpack_public_path__ + "static/img/f5a900273aab67c68c9ce77e6db2fc2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img3.png
// module id = OQZR
// module chunks = 1